// import { getDocumentItemCostInfoColumns } from "../../../../system/providers/plugin/defaultPluginSettings";

let index: number = 0

const RequestForMovementItemsGridPluginSettings: IPluginSettings = {
    name: "Позиции заявки на перемещение",
    mnemocode: "request_for_movement_item_plugin",
    permission: "RequestForMovement",
    columns: [
        {
            order: index++,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД заявки",
            visibility: false,
            width: 200,
        },
        {
            order: index++,
            propertyName: "substanceNameLat",
            propertyType: "string",
            displayName: "МНН (лат.)",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "substanceName",
            propertyType: "string",
            displayName: "МНН (рус.)",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "tradeName",
            propertyType: "string",
            displayName: "ТН (рус.)",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "tradeNameLat",
            propertyType: "string",
            displayName: "ТН (лат.)",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "quantity",
            propertyType: "number",
            displayName: "Количество",
            visibility: true,
            width: 150,
            changeable: true,
        },
        {
            order: index++,
            propertyName: "cureFormName",
            propertyType: "string",
            displayName: "Лек. форма",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "dosage",
            propertyType: "string",
            displayName: "Дозировка",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "nFv",
            propertyType: "string",
            displayName: "Фасовка",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "lots",
            propertyType: "string",
            displayName: "Партии",
            visibility: true,
            width: 150,
        },
        // ...getDocumentItemCostInfoColumns(index, (i) => (index = i)),
    ],
}

export default RequestForMovementItemsGridPluginSettings
